import React from 'react';
import { Layout, Menu as AntMenu, Dropdown, Avatar, Space, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import {
  UserOutlined,
  LogoutOutlined,
  HomeOutlined,
  FileTextOutlined,
  TeamOutlined,
  SettingOutlined,
  KeyOutlined
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useAuthStore } from '../../store/authStore';
import { authService } from '../../services/authService';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();

  const handleLogout = async () => {
    try {
      await authService.logout();
      logout();
      navigate('/login');
    } catch (error) {
      console.error('로그아웃 오류:', error);
    }
  };

  // 사용자 드롭다운 메뉴
  const userMenuItems: MenuProps['items'] = [
    {
      key: 'user-info',
      label: (
        <div>
          <div><strong>{user?.Admin_Name}</strong></div>
          <div style={{ fontSize: '12px', color: '#999' }}>{user?.Admin_ID}</div>
        </div>
      ),
      disabled: true,
    },
    { type: 'divider' },
    {
      key: 'logout',
      label: '로그아웃',
      icon: <LogoutOutlined />,
      onClick: handleLogout,
      danger: true,
    },
  ];

  // 메인 네비게이션 메뉴
  const navMenuItems: MenuProps['items'] = [
    {
      key: 'home',
      label: <Link to="/main">홈</Link>,
      icon: <HomeOutlined />,
    },
    {
      key: 'admin',
      label: <Link to="/admin/list">관리자</Link>,
      icon: <SettingOutlined />,
    },
    {
      key: 'draft',
      label: '기안서',
      icon: <FileTextOutlined />,
      children: [
        {
          key: 'draft-list',
          label: <Link to="/draft/list">기안서 리스트</Link>,
        },
        {
          key: 'draft-regist',
          label: <Link to="/draft/regist">기안서 등록</Link>,
        },
        {
          key: 'draft-tmp',
          label: <Link to="/draft/tmp-list">임시보관함</Link>,
        },
      ],
    },
    {
      key: 'alba',
      label: '일용직',
      icon: <TeamOutlined />,
      children: [
        {
          key: 'alba-list',
          label: <Link to="/alba/list">일용직 리스트</Link>,
        },
      ],
    },
  ];

  return (
    <AntHeader style={{
      background: '#fff',
      padding: '0 24px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      zIndex: 999,
    }}>
      {/* 로고 */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link to="/main" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <h2 style={{ margin: 0, color: '#1890ff', fontWeight: 'bold' }}>ACG ERP</h2>
        </Link>
      </div>

      {/* 메인 네비게이션 */}
      <AntMenu
        mode="horizontal"
        items={navMenuItems}
        style={{
          flex: 1,
          marginLeft: '50px',
          border: 'none',
          background: 'transparent'
        }}
      />

      {/* 사용자 메뉴 */}
      <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
        <Space style={{ cursor: 'pointer' }}>
          <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
          <span>{user?.Admin_Name}</span>
        </Space>
      </Dropdown>
    </AntHeader>
  );
};

export default Header;
